import React, { useEffect, createElement } from 'react';
import { useLocation } from 'react-router-dom';
const SITE_NAME = 'African Union Commission';
const TITLE_MAP: Record<string, string> = {
  '/': 'African Union Commission — Projects & Procurement',
  '/about': 'About Us | African Union Commission',
  '/about-au': 'About the African Union | African Union Commission',
  '/projects': 'Projects | African Union Commission',
  '/bids': 'Bids & Tenders | African Union Commission',
  '/procurement/annual-plan': 'Annual Procurement Plan | African Union Commission',
  '/procurement/contract-awards': 'Contract Awards | African Union Commission',
  '/procurement/unsuccessful-bids': 'Unsuccessful Bid Notifications | African Union Commission',
  '/procurement/manual': 'Procurement Manual | African Union Commission',
  '/procurement/supplier-registration': 'Supplier Registration | African Union Commission',
  '/contact': 'Contact Us | African Union Commission'
};
export function PageTitle() {
  const location = useLocation();
  useEffect(() => {
    const title = TITLE_MAP[location.pathname] || `${SITE_NAME} — Projects & Procurement`;
    document.title = title;
    // Update or create meta description for link previews
    const description = 'Official portal of the African Union Commission for projects, procurement, bids, tenders, and supplier engagement.';
    let metaDesc = document.querySelector('meta[name="description"]');
    if (!metaDesc) {
      metaDesc = document.createElement('meta');
      metaDesc.setAttribute('name', 'description');
      document.head.appendChild(metaDesc);
    }
    metaDesc.setAttribute('content', description);
    // Open Graph title for social/link previews
    let ogTitle = document.querySelector('meta[property="og:title"]');
    if (!ogTitle) {
      ogTitle = document.createElement('meta');
      ogTitle.setAttribute('property', 'og:title');
      document.head.appendChild(ogTitle);
    }
    ogTitle.setAttribute('content', title);
    let ogDesc = document.querySelector('meta[property="og:description"]');
    if (!ogDesc) {
      ogDesc = document.createElement('meta');
      ogDesc.setAttribute('property', 'og:description');
      document.head.appendChild(ogDesc);
    }
    ogDesc.setAttribute('content', description);
  }, [location.pathname]);
  return null;
}